// @ts-check
import React from 'react';
import DatePicker from 'react-datepicker';
import Icon from 'shared/components/Icon';
import QuickFillButton from '../QuickFillButton';
import addBusinessDays from 'date-fns/addBusinessDays';
import differenceInDays from 'date-fns/differenceInDays';
import isWeekend from 'date-fns/isWeekend';

const now = new Date();
const tomorrow = addBusinessDays(now, 1);
const dayAfterTomorrow = addBusinessDays(tomorrow, 1);

const makeDaysOutSetter = (onChange, daysOut) => () =>
  onChange(addBusinessDays(now, daysOut));

export const ReminderDateInput = ({ input }) => {
  const useTomorrow = makeDaysOutSetter(input.onChange, 1);
  const useTwoDays = makeDaysOutSetter(input.onChange, 2);

  const is1Day = input.value && differenceInDays(input.value, tomorrow) === 0;
  const is2Day =
    input.value && differenceInDays(input.value, dayAfterTomorrow) === 0;

  const weekendSelected = input.value && isWeekend(input.value);

  return (
    <div>
      <div className="input-prepend">
        <span className="add-on">
          <Icon name="calendar" />
        </span>
        <div style={{ display: 'inline-block' }}>
          <DatePicker
            className="input-small"
            selected={input.value}
            onChange={input.onChange}
            minDate={now}
          />
        </div>
      </div>
      <div style={{ margin: '8px 0' }}>
        <QuickFillButton active={is1Day} onClick={useTomorrow}>
          1 Day
        </QuickFillButton>
        <QuickFillButton active={is2Day} onClick={useTwoDays}>
          2 Days
        </QuickFillButton>
      </div>
      <div>
        {weekendSelected ? (
          <p style={{ color: 'orange' }}>
            <Icon name="exclamation-triangle" /> Date is on a weekend, you will
            be reminded on the following business day.
          </p>
        ) : null}
      </div>
    </div>
  );
};
